import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { QuoteProvider } from "@/context/QuoteContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuoteDrawer from "@/components/QuoteDrawer";
import ScrollToTop from "@/components/ScrollToTop";
import AdminProtected from "@/components/AdminProtected";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CategoryPage from "@/pages/CategoryPage";
import ContactPage from "@/pages/ContactPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ElectronicsSubCategoryPage from "@/pages/ElectronicsSubCategoryPage";
import ElectronicsProductDetailPage from "@/pages/ElectronicsProductDetailPage";
import FurniturePage from "@/pages/FurniturePage";
import LightingPage from "@/pages/LightingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminQuoteInbox from "@/pages/AdminQuoteInbox";
import AdminQuoteDetail from "@/pages/AdminQuoteDetail";

const PublicLayout = ({ children }) => (
  <QuoteProvider>
    <Navbar />
    <QuoteDrawer />
    {children}
    <Footer />
  </QuoteProvider>
);

const AppShell = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <AdminAuthProvider>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/quotes"
            element={
              <AdminProtected>
                <AdminQuoteInbox />
              </AdminProtected>
            }
          />
          <Route
            path="/admin/quotes/:type/:id"
            element={
              <AdminProtected>
                <AdminQuoteDetail />
              </AdminProtected>
            }
          />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </AdminAuthProvider>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/products/electronics/:sub" element={<ElectronicsSubCategoryPage />} />
        <Route path="/products/electronics/:sub/:productSlug" element={<ElectronicsProductDetailPage />} />
        <Route path="/products/ffe" element={<Navigate to="/products/furniture" replace />} />
        <Route path="/products/furniture" element={<FurniturePage />} />
        <Route path="/products/lighting" element={<LightingPage />} />
        <Route path="/products/:slug" element={<CategoryPage />} />
        <Route path="/products/:slug/:productSlug" element={<ProductDetailPage />} />
      </Routes>
    </PublicLayout>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF9F6] text-[#1A1A1A]">
      <BrowserRouter>
        <ScrollToTop />
        <AppShell />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
